/* eslint-disable complexity */
import {useIntl} from 'react-intl';

import * as store from '@/store';
import Icon, {IconSize} from '@/components/Icon';
import MeetingIcon from './MeetingIcon';
import Tooltip from '@/components/Tooltip';
import treeNodeDocSvg from '@/assets/svg/treeNodeDoc.svg';
import treeNodeDocSelectedSvg from '@/assets/svg/treeNodeDocSelected.svg';
import treeNodeBookSvg from '@/assets/svg/treeNodeBook.svg';
import treeNodeBookSelectedSvg from '@/assets/svg/treeNodeBookSelected.svg';
import treeNodeLockSvg from '@/assets/svg/treeNodeLock.svg';
import treeNodeLockSelectedSvg from '@/assets/svg/treeNodeLockSelected.svg';
import treeNodeUnLockSvg from '@/assets/svg/treeNodeUnLock.svg';
import treeNodeUnLockSelectedSvg from '@/assets/svg/treeNodeUnLockSelected.svg';
import treeNodeSheetSvg from '@/assets/svg/treeNodeSheet.svg';
import treeNodeSheetSelectedSvg from '@/assets/svg/treeNodeSheetSelected.svg';
import treeNodePPTSvg from '@/assets/svg/treeNodePPT.svg';
import treeNodePPTSelectedSvg from '@/assets/svg/treeNodePPTSelected.svg';
import treeNodeDataSheetSvg from '@/assets/svg/treeNodeDataSheet.svg';
import treeNodeDataSheetSelectedSvg from '@/assets/svg/treeNodeDataSheetSelected.svg';
import './index.scss';

type INodeIcon = (props: React.SVGProps<SVGSVGElement>) => React.PropsWithoutRef<React.ReactSVGElement>;

interface IProps {
    // TODO: null 表示不显示图标，待重构
    icon?: INodeIcon | null;
    isInMeeting?: boolean;
    isPagePublic?: boolean;
    isSheet?: boolean;
    isPPT?: boolean;
    isDataSheet?: boolean;
    isInTeam?: boolean;
    isNotInheritRepo?: boolean;
    isSelected?: boolean;
}

const NodeIcon: React.FC<IProps> = ({
    icon, isInMeeting = false,
    isPagePublic = false,
    isSheet = false,
    isPPT = false,
    isDataSheet = false,
    isInTeam = false,
    isNotInheritRepo = false,
    isSelected = false,
}) => {
    const intl = useIntl();
    if (icon) {
        return (
            <div className="tree-node-item-icon-wrap">
                <Icon svg={icon} size={IconSize.Auto} className="tree-node-item-icon" noSpace />
            </div>
        );
    }

    const iconList = [
        [treeNodeDocSvg, treeNodeDocSelectedSvg],
        [treeNodeBookSvg, treeNodeBookSelectedSvg],
        [treeNodeLockSvg, treeNodeLockSelectedSvg],
        [treeNodeUnLockSvg, treeNodeUnLockSelectedSvg],
        [treeNodeSheetSvg, treeNodeSheetSelectedSvg],
        [treeNodePPTSvg, treeNodePPTSelectedSvg],
        [treeNodeDataSheetSvg, treeNodeDataSheetSelectedSvg],
    ];

    let svgItem = iconList[0];
    let textId = '';
    const inMeeting = !store.getRwMode() && isInMeeting;
    if (inMeeting) {
        svgItem = [null, null];
        textId = 'sidebarMeetingTip';
    } else if (isPagePublic) {
        svgItem = iconList[3];
        textId = 'pageIsPublic';
    } else if (isNotInheritRepo) {
        svgItem = iconList[2];
        textId = 'bookIsPublic';
    } else if (isInTeam) {
        svgItem = iconList[1];
    } else if (isSheet) {
        svgItem = iconList[4];
        textId = '';
    } else if (isPPT) {
        svgItem = iconList[5];
        textId = '';
    } else if (isDataSheet) {
        svgItem = iconList[6];
        textId = '';
    } else if (icon === null) {
        return null;
    }

    const svg = isSelected ? svgItem[1] : svgItem[0];

    const iconNode = (
        <div className="tree-node-item-icon-wrap">
            {inMeeting ? (
                <MeetingIcon />
            ) : (
                // <Icon svg={svg} size={IconSize.Auto} className="tree-node-item-icon" noSpace />
                <div
                    style={{
                        backgroundImage: `url(${svg})`,
                    }}
                    className="tree-node-item-icon"
                ></div>
            )}
        </div>
    );

    return inMeeting || isPagePublic || isNotInheritRepo ? (
        <Tooltip
            type={'hover'}
            className={'tree-node-item-icon-tooltip'}
            content={textId && intl.formatMessage({id: textId})}
        >
            {iconNode}
        </Tooltip>
    ) : (
        iconNode
    );
};


export default NodeIcon;
